import { MailingAddressFastSvgComponent } from '../../../../modules/mapfre-design-library/src/lib/svg/mailing-address-svg/mailing-address-fast-svg.component';
import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { PaymentAlertComponent } from '../../../dashboard/loggedin-content/billing/payment-alert/payment-alert.component';
import { MapfreModalComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { ZeroBalanceModalComponent } from '../../../screens/zero-balance-modal/zero-balance-modal.component';
import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { MapfreAlertComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { SystemMaintenanceComponent } from '../../../screens/system-maintenance/system-maintenance.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { BillingDetailsService } from './../../../../_services/my-insurance/billing-details.service';
import {
  FormBaseControlService,
  ModalOptions,
  AlertService,
  AcmicService,
  GTagService,
} from '@mapfre-design-library/src/public_api';
import {
  Component,
  OnInit,
  Input,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaymentServiceService } from '../../../../_services/payment-service/payment-service.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ClientCredentialsService } from '../../../../_services/client-credentials/client-credentials.service';
import { ClientCredentialsTokenService } from '../../../../_services/client-credentials/client-credentials-token.service';
import { environment } from '@env/environment';
import { PolicyDetailsService } from '../../../../_services/my-insurance/policy-details.service';
import { UserDataService } from '../../../../_services/data-services/user-data.service';
import { RedirectToService } from '../../../../_services/payment-service/redirect-to.service';
import { AuthenticationService } from '../../../../_services/_iam/authentication-service.service';
import { CurrentBillService } from './../../../../_services/forms/make-payment/current-bill.service';
import { FlagResponse } from '@models/flag-response';
import { FeatureToggleService } from '../../../../_services/misc-services/feature-toggle.service';
import { PolicyDataService } from '../../../../_services/data-services/policy-data.service';
import { EventService } from '../../../../_services/event-service.service';
import { BillingDataService } from '../../../../_services/data-services/billing-data.service';
import { TranslateService } from '@ngx-translate/core';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { Constants } from '@models/constants';
import { PayBill } from '@models/paybill';
import { UrlValidationService } from '@services/document/url-validation.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, SystemMaintenanceComponent, MapfreAlertComponent, MapfreIputWithValidationComponent, ZeroBalanceModalComponent, MapfreModalComponent, PaymentAlertComponent, MapfreButtonComponent, MailingAddressFastSvgComponent],
  selector: 'app-make-payment-form',
  templateUrl: './make-payment-form.component.html',
  styleUrls: ['./make-payment-form.component.scss'],
})
export class MakePaymentFormComponent implements OnInit {
  @Input() inputs: any;
  makePaymentForm: FormGroup;
  whereToFindModalOptions: ModalOptions;
  payOrCancelModalOptions: ModalOptions;
  makePaymentModalOptions: ModalOptions;
  enableBtn = true;
  loader = false;
  payOrCancelModal = false;
  hideModal = false;
  hideAchGuestModal = false;
  tokenForPayment: any;
  currentBill: any;
  prior2DaysModal = false;
  makePaymentModal = false;
  policyNumberToOpen: any;

  isGuest: boolean;
  showMessage: boolean;
  policy: any;
  policyId: string;
  openPaymentView = false;
  isGuestGWAchDown: boolean;
  isGuestGWCCDCDown: boolean;
  isAcmic: boolean;
  showZeroBalanceModal: boolean;

  constructor(
    private ipt: FormBaseControlService,
    private paymentService: PaymentServiceService,
    private policyDetailsService: PolicyDetailsService,
    private billingDetailsService: BillingDetailsService,
    private route: ActivatedRoute,
    private redirectToService: RedirectToService,
    public router: Router,
    private userDataService: UserDataService,
    private clientCredentialsService: ClientCredentialsService,
    private clientCredentialsTokenService: ClientCredentialsTokenService,
    private alertService: AlertService,
    private authService: AuthenticationService,
    private currentBillService: CurrentBillService,
    private featureToggleService: FeatureToggleService,
    private policyDataService: PolicyDataService,
    private eventService: EventService,
    private billingDataService: BillingDataService,
    private acmicService: AcmicService,
    private gTagService: GTagService,
    private translate: TranslateService,
    private urlValidationService: UrlValidationService
  ) {
    this.isGuestGWCCDCDown = false;
    this.isGuestGWAchDown = false;
    this.showZeroBalanceModal = false;
  }

  detectStateCode() {
    this.isAcmic = this.acmicService.isACMIC();
  }

  onShowMessage() {
    this.showMessage = true;
  }

  onCloseModal() {
    this.showMessage = false;
  }
  onCloseZeroBalanceModal() {
    this.showZeroBalanceModal = false;
  }
  openPayment() {
    this.policyId = this.policy.policynumber.policyNumber;
    if (
      this.policyId &&
      this.policyId.length === 10 &&
      !this.isGuestGWAchDown
    ) {
      this.router.navigate([
        '/make-payment',
        this.policyId,
        'new-guest-payment',
      ]);
    } else {
      this.showMessage = true;
      this.closeModal();
    }
  }
  onMakePayment() {
    let policyNumber =
      this.makePaymentForm.value.makePayment_policy != ''
        ? this.makePaymentForm.value.makePayment_policy.trim()
        : this.makePaymentForm.value.makePayment_policy;
    if (policyNumber.length === 7) {
      policyNumber = policyNumber.substring(0, 6);
    }
    if (policyNumber.length === 6 && this.isGuest) {
      this.showMessage = true;
    } else {
      this.loader = true;
      const zipcode = this.makePaymentForm.value.makePayment_zip;
      this.paymentService.setData(zipcode, policyNumber);
      this.enableBtn = false;

      if (/^800803[0-9]{7}$/.test(policyNumber)) {
        this.redirectToService.onPromise().then(() => {
          this.createTWGuestPayment(policyNumber, zipcode);
        });
        this.loader = false;
        this.enableBtn = true;
      } else {
        this.initiateGuestPayment(policyNumber, zipcode);
      }
    }
  }

  initiateGuestPayment(policyNumber: string, zipcode: string) {
    this.paymentService.initiateGuestPayment(policyNumber, zipcode).subscribe(
      (response) => {
        if(response.guestPaymentStatus !== 1){
          this.issueContactUsMessage();
          return;
        }
        this.gTagService.triggerFormLink('makePaymentForm', 'true', '');
        this.loader = false;
        this.enableBtn = true;
        this.updateSubmitButton();
        this.tokenForPayment = response.paymentusToken;
        this.paymentService.setGuestSessionToken(response.sessionToken);

        if (policyNumber.length === 10) {
          if(Object.keys(response.policyData).length === 0 || response?.currentBills.length === 0){
            this.paymentUsRedirection(this.tokenForPayment);
            return;
          }
          this.policy = response.policyData;
          this.handleCurrentBillData(response.currentBills);
        } else if (policyNumber.length !== 13) {
          this.createGuestPayment(policyNumber);
        } else {
          this.createTWGuestPayment(policyNumber, zipcode);
        }
      },
      () => {
        this.loader = false;
        this.enableBtn = true;
        this.gTagService.triggerFormLink(
          'makePaymentForm',
          'false',
          this.translate.instant('NOT_FOUND')
        );
        this.alertService.error(
          `We couldn't verify your policy details, please review and try again`
        );
      }
    );
  }

  issueContactUsMessage() {
    this.loader = false;
    this.enableBtn = false;
    this.alertService.error(
      `Your renewal invoice is currently being processed. As a result, make a payment is temporarily unavailable for 24 hours.
      If you would like to make a payment prior to that point please
      contact our Customer Service Department at 1-855-Mapfre7 (1-855-627-3737).`
    );
  }
  hideModalAction(): void {
    this.hideModal = !this.hideModal;
    this.closeModal();
  }
  hideOnClick(event) {
    if (!event.target.closest('.modal-body')) {
      this.closeModal();
    }
  }

  closeModal() {
    this.hideModal = true;
    this.hideAchGuestModal = true;
    this.payOrCancelModal = false;
    this.prior2DaysModal = false;
    this.makePaymentModal = false;
  }

  makePayment() {
    this.closeModal();

    if (this.checkToOpenAchGuestModal()) {
      this.makePaymentModal = true;
    } else {
      this.paymentUsRedirection(this.tokenForPayment);
    }
  }
  makeDebitOrCreditPayment() {
    const policyNumber =
      this.makePaymentForm.value.makePayment_policy != ''
        ? this.makePaymentForm.value.makePayment_policy.trim()
        : this.makePaymentForm.value.makePayment_policy;
    this.closeModal();
    if (policyNumber && policyNumber.length === 10 && !this.isGuestGWCCDCDown) {
      // debit or credit
      this.router.navigate(['/make-payment-guest'],{
        state:{
          zipCode:this.makePaymentForm.value.makePayment_zip
        }
      })
    } else {
      this.showMessage = true;
      this.closeModal();
    }
  }

  checkToOpenAchGuestModal() {
    if (
      ['AUTO', 'UMBRELLA', 'HOME'].includes(this.policy.policyType) &&
      this.currentBill.badCheckCount === 'N'
    ) {
      return true;
    } else {
      return false;
    }
  }

  invokeCurrentBill(policyNumber) {
    this.currentBillService.getCurrentBill(policyNumber).subscribe(
      (currentBill) => {
        this.handleCurrentBillData(currentBill);
      },
      () => {
        this.paymentUsRedirection(this.tokenForPayment);
      }
    );
  }

  handleCurrentBillData(currentBill) {
    this.currentBill = currentBill[0];
    if (this.currentBill.outstandingbalance === 0 && this.currentBill.priorYearBalance === 0) {
      this.showZeroBalanceModal = true;
      return;
    }
    if (this.currentBill.priorYearBalance > 0) {
      this.policy.hasPriorYearBalance = true;
      this.policy.priorYearBalance = {
        theAmount: this.currentBill.priorYearBalance,
      };
    }
    this.billingDataService.updateBillingDetails(this.currentBill);
    this.policyDataService.updatePolicyDetails([this.policy]);
    this.policy.billingDetails = currentBill;
    this.payOrCancelModal = true;
    if (!this.payOrCancelModal) {
      if (this.checkToOpenAchGuestModal()) {
        this.makePaymentModal = true;
      } else {
        this.paymentUsRedirection(this.tokenForPayment);
      }
    }
  }
  paymentUsRedirection(token) {
    const url = `${environment.paymentus_guest}${token}&brand=${this.isAcmic ? 'AAA' : 'MAPFRE'
      }`;
    if (this.urlValidationService.isApprovedRedirectUrl(url)) {
      if (Capacitor.isNativePlatform()) {
        Browser.open({ url });
      } else {
        const mapForm = document.createElement('form');
        mapForm.setAttribute('style', Constants.DISPLAY_NONE);
        mapForm.target = 'Map';
        mapForm.method = 'POST';
        mapForm.action = `${environment.paymentus_guest}${token}&brand=${this.isAcmic ? 'AAA' : 'MAPFRE'
          }`;
        document.body.appendChild(mapForm);

        const map = window.open('', 'Map');

        if (map) {
          mapForm.submit();
        } else {
          alert('Please turn off the popup blocker');
        }

        document.body.removeChild(mapForm);
      }
    }
  }

  createGuestPayment(policyNumber) {
    const mapForm = document.createElement('form');
    mapForm.setAttribute('style', Constants.DISPLAY_NONE);
    mapForm.target = 'Map';
    mapForm.method = 'POST';
    mapForm.action = environment.guest_paybill;

    const mapInput = document.createElement('input');
    mapInput.setAttribute('type', 'text');
    mapInput.setAttribute('name', 'policyNumber');
    mapInput.setAttribute('value', policyNumber);

    document.body.appendChild(mapForm);

    let map: any;

    if (this.urlValidationService.isApprovedRedirectUrl(environment.paybill_link_app)) {

      if (Capacitor.isNativePlatform()) {
        Browser.open({ url: environment.paybill_link_app });
      } else {
        map = window.open('', 'Map');

        this.redirectToService.onPromise().then(() => {
          this.onResolvingRedirectTo(map, mapForm);
        });
      }
    }
  }

  createTWGuestPayment(policyNumber, zipcode) {

    let payBill = PayBill.CA

    if (policyNumber.startsWith("64") && policyNumber.substring(3, 6) == "104") {
      payBill = PayBill.CA_64_104
    } else if (policyNumber.startsWith("64")) {
      payBill = PayBill.CA_64
    }

    const mapForm = document.createElement('form');
    mapForm.setAttribute('style', Constants.DISPLAY_NONE);
    mapForm.target = 'Map';
    mapForm.method = 'POST';
    mapForm.action = payBill.url;

    const mapInput = document.createElement('input');
    mapInput.setAttribute('type', 'text');
    mapInput.setAttribute('name', 'txtAcctNumber');
    mapInput.setAttribute('value', policyNumber + ";" + zipcode);

    const mapInput2 = document.createElement('input');
    mapInput2.setAttribute('type', 'text');
    mapInput2.setAttribute('name', 'txtSource');
    mapInput2.setAttribute('value', payBill.source);

    mapForm.appendChild(mapInput);
    mapForm.appendChild(mapInput2);
    document.body.appendChild(mapForm);

    const map = window.open('', 'Map');

    this.redirectToService.onPromise().then(() => {
      this.onResolvingRedirectTo(map, mapForm);
    });
  }

  onResolvingRedirectTo(map, mapForm) {
    if (map) {
      mapForm.submit();
    } else {
      alert('Please turn off the popup blocker');
    }
    document.body.removeChild(mapForm);
  }

  errorResponseHandle(error) {
    this.gTagService.triggerFormLink(
      'makePaymentForm',
      'false',
      this.translate.instant('MAKE_PAYMENT_ERROR')
    );
    this.loader = false;
    if (error.status === 400) {
      this.updateSubmitButton();
      this.router.navigate(['/make-payment-epay']);
    } else {
      this.alertService.error(
        "We couldn't find your policy please review your details"
      );
    }
  }

  fetchFeture() {
    this.featureToggleService.isAvailable(3).subscribe(
      (response) => {
        if (response) {
          this.isGuest = response.isAvailable;
        }
      },
      () => {
        this.isGuest = false;
      }
    );
  }
  fetchFeatureGuestPayment() {
    this.featureToggleService.getFeatureToggles().subscribe(
      (response: FlagResponse) => {
        this.isGuestGWAchDown = response.ach;
        this.isGuestGWCCDCDown = response.isCCDC;
      },
      () => {
        this.isGuestGWAchDown = false;
        this.isGuestGWCCDCDown = false;
      }
    );
  }
  clientCredentials() {
    if (!this.clientCredentialsTokenService.getToken()) {
      this.clientCredentialsService.getToken().subscribe(
        () => {
          this.fetchFeture();
          this.fetchFeatureGuestPayment();
        }
      );
    } else {
      this.fetchFeture();
    }
  }

  updateSubmitButton() {
    if (!this.enableBtn) {
      this.enableBtn = true;
    }
  }

  closeNewPayment() {
    this.openPaymentView = false;
    this.makePaymentModal = false;
  }

  preFillQueryParams() {
    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams['policyNumber']) {
        this.makePaymentForm.controls.makePayment_policy.setValue(
          queryParams['policyNumber'].trim()
        );
      }
      if (queryParams['zipCode']) {
        this.makePaymentForm.controls.makePayment_zip.setValue(
          queryParams['zipCode'].trim()
        );
      }
    });
  }

  ngOnInit() {
    this.detectStateCode();
    this.authService.logout();
    let buttonCopy = 'WHERE_CAN_FIND_MY_POLICY_INFO';
    let additionalButtonClasses =
      'no-padding-horizontal link-button red-link normal-text underline';
    if (this.isAcmic) {
      buttonCopy = 'MODAL_WHERE_CAN_I_LINK';
      additionalButtonClasses =
        'small blue-link guest-mk-payment font-weight text-capitalize';
    }
    this.whereToFindModalOptions = new ModalOptions({
      additionalClasses: 'modal-small center-on-page modal-dialog signuptitle',
      additionalButtonClasses,
      animatePosition: 'bottom',
      buttonCopy,
      modalId: 'helpModal',
      modalTranslateCopy: 'LOCATE_YOUR_POLICY_INFORMATION',
      typeOfModal: 'default',
      modalName: 'make-payment_Where_To_Find',
    });
    let headerIconClass = '';
    if (this.isAcmic) {
      headerIconClass = 'info_outline';
    }

    this.payOrCancelModalOptions = new ModalOptions({
      animatePosition: 'top',
      onLoad: true,
      headerIconClass,
      iconClasses: 'info_outline',
      iconFamily: 'material-icons',
      screenReader: true,
      showIcons: true,
      additionalHeaderClasses: 'bigger-font-size',
      additionalButtonClasses: 'ghost primary w100 h24 no-padding x-small-btn',
      additionalClasses:
        'pay-now-modal modal-medium modal-dialog center-on-page modal-dialog-scrollable',
      modalId: 'payCancel',
      modalTranslateCopy: `${this.isAcmic ? 'MODAL_MAKE_A_PAYMENT' : ''}`,
      size: 'modal-medium',
      typeOfModal: 'default',
      modalName: 'make-payment_payOrCancel',
    });
    this.makePaymentModalOptions = new ModalOptions({
      animatePosition: 'top',
      onLoad: true,
      headerIconClass: 'info_outline',
      iconClasses: 'info_outline',
      iconFamily: 'material-icons',
      screenReader: true,
      showIcons: true,
      additionalButtonClasses: 'ghost primary w100 h24 no-padding x-small-btn',
      additionalClasses:
        'pay-now-modal modal-small modal-dialog center-on-page modal-dialog-scrollable',
      modalId: 'makePayModal',
      modalTranslateCopy: `${this.isAcmic ? 'MAKE_A_PAYMENT_WITH' : ''}`,
      size: 'modal-small',
      typeOfModal: 'default',
      modalName: 'make-payment',
    });

    this.makePaymentForm = this.ipt.toFormGroup(this.inputs);
    this.clientCredentials();
    const preFill = this.paymentService.getData();
    if (preFill) {
      this.makePaymentForm.controls.makePayment_policy.setValue(
        preFill['policyNumber'] || ''
      );
      this.makePaymentForm.controls.makePayment_zip.setValue(
        preFill['zipcode'] || ''
      );
    }
    this.preFillQueryParams();

    this.makePaymentForm.controls.makePayment_policy.valueChanges.subscribe(
      () => {
        this.updateSubmitButton();
      }
    );

    this.makePaymentForm.controls.makePayment_zip.valueChanges.subscribe(
      () => {
        this.updateSubmitButton();
      }
    );
  }
}